export const url = "https://forms.gle/da8iNMZFdRRgqvey6";

export default {
  url,
};
